import React from "react";
import { useState } from "react";
import { useEffect } from "react";


export default function MailBoxesIntegration({
    isOutlook,
    setIsOutlook,
    isGmailAuthenticated,
    isOutlookAuthenticated,
}) {



    return (

        <div className="flex  gap-1  text-sm   w-fit mx-auto">
            {/* Outlook Button */}
            {isOutlookAuthenticated && (
            <button
                title="Outlook"
                className={`px-2 md:px-3  hover:bg-zinc-700 border border-zinc-700 rounded-t-xl br-1 text-white  transition-all duration-200 
                  ${isOutlook ? "bg-zinc-100" : "bg-zinc-800"}`}
                onClick={() => setIsOutlook(true)}
            >
                <img
                src="/assets/icons8-microsoft-outlook.svg"
                alt="Outlook"
                className="h-5 w-5 md:h-6 md:w-6"
                />
            </button>
            )}

            {/* Gmail Button */}
            {isGmailAuthenticated && (
            <button
                title="Gmail"
                className={`px-2 md:px-3  hover:bg-zinc-700 border border-zinc-700 rounded-t-xl br-1 text-white  transition-all duration-200 
                  ${!isOutlook ? "bg-zinc-100" : "bg-zinc-800"}`}
                onClick={() => setIsOutlook(false)}
            >
                <img 
                src="/assets/icons8-gmail.svg"
                alt="Gmail"
                className="h-5 w-5 md:h-6 md:w-6"
                />

            </button>
            )}
        </div>
    );
}